import { expandTabBlock, findTabBlocks } from './tab-line.js'

/**
 * True when the text is a single ASCII tab and nothing else. Spec 2026-08-25 §6.
 *
 * Block-aware rather than a line count. The previous implementation counted matching lines across
 * the whole paste and capped at six, so a two-stanza tab (12 rows) failed and fell silently to the
 * song path. Multi-block pastes still go to the song path — deliberately, so each stanza becomes its
 * own element — but now because there is more than one block, not because a counter overflowed.
 */
export function isAsciiTab(tab: string): boolean {
  const lines = tab.split('\n')
  const blocks = findTabBlocks(lines)
  if (blocks.length !== 1) {
    return false
  }
  // Expand first. Spec §7a: a tab's palm-mute, count and `Tuning:` rows are neither string rows nor
  // blank, so checking before expanding sent every ornament-carrying tab to the song path — where
  // the tokenizer normalised the text before §7's absorption could ever run.
  const { start, end } = expandTabBlock(lines, blocks[0])
  // Everything outside the block must be blank, or this is a chart, not a bare tab.
  return lines.every((line, i) => (i >= start && i <= end ? true : line.trim() === ''))
}
